<template>
  <v-dialog v-model="internal" persistent :max-width="width" overlay-opacity="0.59">
    <v-card class="pa-5" data-testid="delete-modal">
      <div class="d-flex align-start mb-4">
        <div>
          <div class="text-h6">{{ title || $t('deleteModal.title') }}</div>
          <div v-if="itemLabel" class="font-weight-bold mt-1">Item: {{ itemLabel }}</div>
        </div>
      </div>
      <div class="text-body-2 mb-2">{{ message || $t('deleteModal.message') }}</div>
      <slot />
      <div class="text-caption grey--text mb-6">{{ $t('deleteModal.warning') }}</div>
      <div class="d-flex justify-end flex-gap-2">
        <v-btn text :disabled="loading" @click="close">{{ $t('instructions.cancel') }}</v-btn>
        <v-btn data-testid="confirm-delete" color="red" :loading="loading" :disabled="loading" @click="$emit('confirm')">
          {{ confirmText || $t('instructions.delete') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteModal',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    itemLabel: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    width: { type: [String, Number], default: 500 }
  },
  computed: {
    internal: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    }
  },
  methods: {
    close () {
      if (!this.loading) this.$emit('input', false)
    }
  }
}
</script>
